import { Flex, Shimmer } from '@/_components';
import styles from './QuestionnaireNavigationLoading.module.css';
import type { FC } from 'react';

export const QuestionnaireNavigationLoading: FC = () => {
  return (
    <>
      <Flex
        isColumn={true}
        padding={2}
        isXCentered={true}
        gap={2}
        className={styles.questionnaireNavigationLoadingTablet}
      >
        <Shimmer
          height={48}
          width={48}
          paddingTop={8}
          paddingBottom={8}
          paddingInline={8}
        />
        <Shimmer
          height={48}
          width={48}
          paddingTop={16}
          paddingInline={16}
          paddingBottom={16}
          isRounded={true}
        />
        <Shimmer
          height={48}
          width={48}
          paddingTop={16}
          paddingInline={16}
          paddingBottom={16}
          isRounded={true}
        />
      </Flex>
      <Flex
        isColumn={true}
        padding={2}
        gap={2}
        className={styles.questionnaireNavigationLoadingDesktop}
      >
        <Flex gap={6} isYCentered={true} paddingY={8}>
          <Shimmer height={18} width={18} isRounded={true} />
          <Shimmer
            height={48}
            width={120}
            paddingTop={16}
            paddingBottom={16}
            isRounded={true}
          />
        </Flex>
        <Flex gap={6} isYCentered={true} paddingY={8}>
          <Shimmer height={18} width={18} isRounded={true} />
          <Shimmer
            height={48}
            width={120}
            paddingTop={16}
            paddingBottom={16}
            isRounded={true}
          />
        </Flex>
        <Flex gap={6} isYCentered={true} paddingY={8}>
          <Shimmer height={18} width={18} isRounded={true} />
          <Shimmer
            height={48}
            width={120}
            paddingTop={16}
            paddingBottom={16}
            isRounded={true}
          />
        </Flex>
      </Flex>
    </>
  );
};
